import React from 'react'
import ComparatorsGrid from 'src/components/pages/comparators/ComparatorsGrid'
import Layout from 'components/shared/Layout'
import Separator from 'components/shared/Separator'
import Link from 'components/shared/Link'
import { Title, Text } from 'components/typo'
import SmallArrow from 'src/components/icons/SmallArrow'
import css from './styles.module.scss'

const RelatedComparators = ({ comparators }) => {
  const theme = 'green'

  return (
    <Layout type="maxWidth" className={css.RelatedComparators}>
      <Layout type="wrapper">
        <div className={css.head}>
          <Title size="big">Compare</Title>
          <Link className={css.link} href="/headless-cms/comparison">
            <Text className={css.linkText} theme={theme}>
              See all our comparators
            </Text>
            <SmallArrow className={css.arrow} theme={theme} />
          </Link>
        </div>
        <Separator className={css.separator} />
        <div className={css.RelatedComparators}>
          <ComparatorsGrid comparators={comparators} />
        </div>
      </Layout>
    </Layout>
  )
}

export default RelatedComparators
